import { defineMessages } from 'react-intl';
import { EditSlot } from './components';
import { slots } from './reducers';

defineMessages({
  slots: {
    id: 'slots',
    defaultMessage: 'Side menu',
  },
});

const applyConfig = (config, intl) => {
  // reducers
  config.addonReducers = {
    ...config.addonReducers,
    slots,
  };

  // routes
  config.addonRoutes.push({ path: '/edit-slot/:id', component: EditSlot }, { path: '/**/edit-slot/:id', component: EditSlot });
  config.settings.nonContentRoutes.push('/edit-slot', /\/edit-slot\/.*$/);

  // add group
  config.blocks.groupBlocksOrder.push({ id: 'slots', title: 'Slots' });

  // config slots
  config.slots = {
    asideLeftSlot: {
      id: 'left_column',
      title: 'Coluna da esquerda',
      manage: true,
      items: [],
    },
  };

  return config;
};

export default applyConfig;
